
import {Vue, Component} from 'vue-property-decorator';
import {integrityApi} from "@/api/integrity";

const {regionData, CodeToText} = require("@/js/region/region");
import SelectMechanism from "@/components/SelectMechanism.vue";
import ckeditor4 from "@/components/CkeditorComponent.vue";
import CreditListCommon from "@/views/integrity/CreditListCommon.vue";

@Component({
  components: {
    CreditListCommon,
    ckeditor4, SelectMechanism
  }
})
export default class Order extends Vue {
  private dataList = [];// 企业列表
  private showQuery = false;
  private loading = false;
  private queryParams = {
    start: '',
    end: '',
    resultsName: '',
    sourceName: '',
    unitInvolvedName: '',
    userName: '',
    handlingUser: '',
    current: 1,
    size: 10,
    total: 0
  }
  userData = {} as any;
  private showAddDialog = false;
  private formRule = {
    unitInvolvedName: [{required: true, message: '请输入', trigger: 'change'}],
    handlingUnitName: [{required: true, message: '请输入', trigger: 'change'}],
    sourceName: [{required: true, message: '请选择', trigger: 'change'}],
    complaintDate: [{required: true, message: '请选择', trigger: 'change'}],
    userMobile: [{required: true, message: '请输入', trigger: 'blur'}],
    userName: [{required: true, message: '请输入', trigger: 'blur'}],
    resultsName: [{required: true, message: '请选择', trigger: 'change'}],
    typeName: [{required: true, message: '请选择', trigger: 'change'}],
    content: [{required: true, message: '请输入', trigger: 'blur'}],
    handlingUser: [{required: true, message: '请输入', trigger: 'blur'}]
  }
  private dataInfo = {
    unitInvolved: '',
    unitInvolvedName: '',
    unitInvolvedNameId: '',
    handlingUnit: '',
    handlingUnitName: '',
    handlingUnitNameId: '',
    sourceName: '',
    complaintDate: '',
    userMobile: '',
    userName: '',
    resultsName: '',
    typeName: '',
    content: '',
    handlingUser: '',
  } as any;
  private mode = "";

  mounted() {
    const userData = this.$store.state.AuthedUser;
    console.log(userData);
    this.userData = userData;
    this.loadData();
  }

  reset() {
    this.queryParams.start = '';
    this.queryParams.end = '';
    this.queryParams.resultsName = '';
    this.queryParams.sourceName = '';
    this.queryParams.unitInvolvedName = '';
    this.queryParams.userName = '';
    this.queryParams.handlingUser = '';
    this.loadData();
  }

  resetFrom() {
    this.dataInfo.unitInvolved = '';
    this.dataInfo.unitInvolvedName = '';
    this.dataInfo.unitInvolvedNameId = '';
    this.dataInfo.handlingUnit = '';
    this.dataInfo.handlingUnitName = '';
    this.dataInfo.handlingUnitNameId = '';
    this.dataInfo.sourceName = '';
    this.dataInfo.complaintDate = '';
    this.dataInfo.userMobile = '';
    this.dataInfo.userName = '';
    this.dataInfo.resultsName = '';
    this.dataInfo.typeName = '';
    this.dataInfo.content = '';
    this.dataInfo.handlingUser = '';
  }

  loadData() {
    this.clearSelectedTable();
    this.showQuery = false;
    this.loading = true;
    integrityApi.pageComplaint(this.queryParams).then((r: any) => {
      this.loading = false;
      const res = r.data;
      if (res.result === 0) {
        this.queryParams.total = res.data.total;
        this.dataList = res.data.records;
      }
    }).catch(() => {
      this.loading = false;
    })
  }

  pageSizeChange(val: number) {
    this.queryParams.size = val;
    this.loadData();
  }

  pageCurrentChange(val: number) {
    this.queryParams.current = val;
    this.loadData();
  }

  indexMethod(index: any) {
    return (this.queryParams.current - 1) * this.queryParams.size + index + 1;
  }

  onView() {
    if(this.isCheckedOne()){
      this.resetFrom();
      this.mode = "view";
      this.dataInfo = JSON.parse(JSON.stringify(this.selectedItems[0]));
      this.showAddDialog = true;
    }
  }

  onDelete(){
    if(this.isCheckedOne()){
      this.$confirm('确定要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const dataInfo = this.selectedItems[0] as any;
        integrityApi.deleteComplaint({id: dataInfo.id, unitInvolved: dataInfo.unitInvolved}).then((r: any) => {
          if(r.data.result === 0){
            this.$message.success("删除成功！");
            this.loadData();
          }
        });
      });
    }
  }

  onClickTableView(row: any){
    this.resetFrom();
    this.mode = "view";
    this.dataInfo = JSON.parse(JSON.stringify(row));
    this.showAddDialog = true;
  }

  openAddDialog() {
    this.resetFrom();
    this.dataInfo.handlingUnitName = this.userData.organizationName;
    this.dataInfo.handlingUnit = this.userData.organizationId;
    this.mode = 'save';
    this.showAddDialog = true;
  }

  onClose() {
    this.resetFrom();
    let form = this.$refs.form as HTMLFormElement;
    form.resetFields();
    this.mode = '';
    this.showAddDialog = false;
  }

  onSave() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        integrityApi.addComplaint(this.dataInfo).then((r: any) => {
          if (r.data.result === 0) {
            this.$message.success("操作成功！");
            this.loadData();
            this.onClose();
          }
        });
      }
    });
  }

  changeOrg(val: any) {
    this.dataInfo.unitInvolved = val.mechanismId;
    this.dataInfo.unitInvolvedName = val.mechanismName;
  }

  private selectedItems = [];
  onSelectItem(selection: any, row: any) {
    this.selectedItems = selection;
  }

  isCheckedOne(){
    if(this.isChecked()){
      if(this.selectedItems.length !== 1){
        this.$message.error("请先选择一条记录");
        return false;
      }
    }
    return true;
  }

  isChecked(){
    if(!this.selectedItems || this.selectedItems.length === 0){
      this.$message.error("请先选择一条记录");
      return false;
    }

    return true;
  }
  clearSelectedTable(){
    this.selectedItems = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
  }
}
